import * as Yup from "yup";

/**
 * Validation schema rule for billing amount
 */
export const BillingAmountSchema = Yup.object().shape({
  billing: Yup.array().of(
    Yup.object().shape({
      code: Yup.string().trim(),
      amount: Yup.string()
        .trim()
        .required("Amount is required.")
        .test("is-decimal", "Amount is invalid.", (value) =>
          /^(?!.*[eE])^(?=.*[1-9])\d*(\.\d{1,2})?$/.test(value)
        ),
    })
  ),
  rpmBilling: Yup.array().of(
    Yup.object().shape({
      code: Yup.string().trim(),
      amount: Yup.string()
        .trim()
        .required("Amount is required.")
        .test("is-decimal", "Amount is invalid.", (value) =>
          /^(?!.*[eE])^(?=.*[1-9])\d*(\.\d{1,2})?$/.test(value)
        ),
    })
  ),
});
